import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useValidator } from 'src/features/general/enquete-create/hooks/useValidator';
import InputRadioGroup from './InputRadioGroup';
import { CAN_REVERT } from 'src/constants';

type Props = {
  methods: UseFormReturn<any>;
  canRevert: boolean;
};

export const CanRevertForm = ({ methods, canRevert }: Props) => {
  const { rulesCanRevert } = useValidator(methods);
  const { t } = useTranslation();
  return (
    <InputRadioGroup
      name={'canRevert'}
      defaultValue={canRevert ? CAN_REVERT.ON : CAN_REVERT.OFF}
      control={methods.control}
      rules={rulesCanRevert}
      getValues={methods.getValues}
      list={[
        { value: CAN_REVERT.ON, label: t('enqueteGeneralCommon.canRevertEnabled') },
        { value: CAN_REVERT.OFF, label: t('enqueteGeneralCommon.canRevertDisabled') },
      ]}
      disabled={false}
    />
  );
};
